/**
 * Internal dependencies
 */
import BlockSlider from "./block-slider";
import ViewportManager from "./viewport-manager";

/**
 * 
 */
class BlockSliderManager {

	/**
	 * Public vars
	 */

	/**
	 * @type Document
	 */
	contextDocument = document;

	/**
	 * @type Array
	 */
	blockSliderList = [];

	/**
	 * @type String
	 */
	blockSliderSelector = '.block-slider';

	/**
	 * @type Array
	 */
	customSliderList = [];

	/**
	 * @type String
	 */
	customSliderBaseClass = 'custom-slider';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		this.contextDocument.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		/**
		 * Block sliders
		 */
		this.blockSliderList.forEach( ( slider ) =>
		{
			slider.clear();
		} );

		this.blockSliderList = [];

		/**
		 * Custom sliders
		 */
		this.customSliderList.forEach( ( slider ) =>
		{
			slider.clear();
		} );

		this.customSliderList = [];
	}

	/**
	 * 
	 */
	setup()
	{
		/**
		 * @type String
		 */
		const viewportCurrent = ViewportManager.getCurrentViewport();

		/**
		 * Block sliders
		 */
		this.contextDocument.querySelectorAll( this.blockSliderSelector ).forEach( ( sliderElement ) =>
		{
			const slider = new BlockSlider( sliderElement );
			slider.setup();
			this.blockSliderList.push( slider );
		} );

		/**
		 * Custom sliders
		 */
		this.contextDocument.querySelectorAll( `.${viewportCurrent}-${this.customSliderBaseClass}` ).forEach( ( sliderElement ) =>
		{
			const slider = new BlockSlider( sliderElement, {
				settingsAttributeBaseName: 'slider-settings',
				swiperSlideSelector: sliderElement.getAttribute( `${viewportCurrent}-slider-s-sel` ),
				swiperWrapperSelector: sliderElement.getAttribute( `${viewportCurrent}-slider-w-sel` ),
			} );
			slider.setup();
			this.customSliderList.push( slider );
		} );
	}

	/**
	 * Event handlers
	 */

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockSliderManager;